import React from 'react';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export interface Props {
  insuranceName: string;
  onEdit(): void;
  onDelete(): void;
}

export const TableActions = ({ insuranceName, onEdit, onDelete }: Props) => {
  return (
    <Box as="td" css="text-align: right; white-space: nowrap">
      <IconButton
        icon="far fa-pencil"
        variant="subtleInactive"
        onClick={onEdit}
        aria-label={`Edit ${insuranceName}`}
      />

      <IconButton
        icon="far fa-minus-circle"
        variant="subtleInactive"
        onClick={onDelete}
        aria-label={`Delete ${insuranceName}`}
      />
    </Box>
  );
};
